const MILLISECONDS_PER_HOUR = 3_600_000;

export const GRAMMAR_CHECKPOINT_SIZE = 20;

export const GRAMMAR_CHECKPOINT_MAX_ITEMS_PER_POINT = 2;

export const GRAMMAR_CHECKPOINT_TOKEN_TTL_MS: number = 2 * MILLISECONDS_PER_HOUR;

export const GRAMMAR_CHECKPOINT_HISTORY_LIMIT = 20;
